import React from 'react';
import { Box, Grid, Grow, Typography } from '@mui/material';
import SignInImg from 'Assets/Images/login.png'
import RegForm from './RegForm';

const ADDITIONAL_INFO = [
    `✓ Institutional memory (advisor-independent)`,
    `✓ Cross-domain optimization (tax + investment + succession synchronized)`,
    `✓ Real-time intelligence (not annual snapshots)`,
    `✓ Generational knowledge transfer (wealth strategy codified)`,
    `✓ Risk mitigation (proactive alerts, compliance automation)`,
    `✓ Governance alignment (family coordination)`,
    `✓ Cost efficiency (cost reduction + better outcomes)`,
    `✓ Private communication with professionals within the platform`,
    `✓ Secure, intelligent digital vault for advisor collaboration`,
    `✓ AI concierge for identifying and recommending professional experts for specific family wealth processes`,
    `✓ AI-assisted monitoring of deliverable schedules with stakeholder notifications`,
    `✓ AI-generated draft documents for expert review`,
    `✓ AI assistant for document insight and Q&A`,
];

const Client = () => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'linear-gradient(to right, #041e42, #78a8e6)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                p: 2,
            }}
        >
            <Grid container spacing={0}>
                {/* Left Side */}
                <Grow in timeout={1000}>
                    <Grid item xs={12} md={5} sx={{ color: 'white', p: 4, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ lineHeight: 1.4 }}>
                            WealthEI Vault's core value isn't the individual services—it's the integration, continuity, and proactivity that traditional advisory can't match.
                        </Typography>
                        <Typography variant="body1" gutterBottom sx={{ mb: 2, fontSize: 18 }}>
                            Families don't just get cheaper AI-delivered services; they get:
                        </Typography>
                        <ul style={{ listStyle: 'none', paddingLeft: 0, lineHeight: 1.6, fontSize: 14 }}>
                            {ADDITIONAL_INFO.map((info, index) => (
                                <li key={index}>{info}</li>
                            ))}
                        </ul>

                        <Box component="img" src={SignInImg} alt="illustration" sx={{ width: '60%', maxWidth: 400, mt: 4 }} />
                    </Grid>
                </Grow>

                {/* Right Side */}
                <Grid item xs={12} md={7}>
                    <RegForm />
                </Grid>
            </Grid>
        </Box>
    )
}

export default Client;